import styled from "@emotion/styled"

const HeroScrollPcDemoDesktop = styled.div`
  background-color: ${({ theme }) => theme.palette.gray[50]};
  border: 5px solid ${({ theme }) => theme.palette.common.white};
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0px 13px 22px -15px #09280d40;
  aspect-ratio: 16 / 9;

  & > * {
    width: 100%;
    height: 100%;
  }
`

export default HeroScrollPcDemoDesktop
